export default __webpack_public_path__ + "static/social-infographics_en-1d958b1fdf9b925877986060cf55d49b.png";